import axios from "axios";
import { API_URL } from "src/scenes/App";
import React, { Component } from "react";
import { SetupPasswordContainerContext } from "src/components/SetupPasswordContainerContext";
import WellDone from "./components/WellDone";
import {
    AuthDescription, AuthForm, AuthInput, AuthPrimaryButton, AuthSurface, AuthTitle, ErrorLabel, LottieLoadingIndicator
} from "src/components";
import { getAppDetails } from "src/config/appVariants";

const SetupPasswordError = {
    EMPTY_PASSWORD: 1,
    EMPTY_CONFIRM_PASSWORD: 2,
    DIFF_PASS: 3, 
    MIN_LENGTH: 4
};

const ErrorStrings = {
    [SetupPasswordError.EMPTY_PASSWORD]: "* Please enter a password",
    [SetupPasswordError.EMPTY_CONFIRM_PASSWORD]: "* Please re-enter the same password",
    [SetupPasswordError.DIFF_PASS]: "* Please make sure passwords match",
    [SetupPasswordError.MIN_LENGTH]: "* Please enter a password at least eight characters long",
};

class SetupPassword extends Component {
    state = {
        isShowWellDone: false,
    };

    static contextType = SetupPasswordContainerContext;

    showWellDone = (isShow) => {
        this.setState({ 
            isShowWellDone: isShow
        });
    };

    render() {
        const { accessCode, businessName, appVariant } = this.context;
        const app = getAppDetails(appVariant);

        if (this.state.isShowWellDone)
            return <WellDone />;

        return <AuthSurface><AuthTitle>Welcome to {app.displayName}!</AuthTitle><AuthDescription>Access Code: {accessCode}</AuthDescription><AuthDescription>You have received an invitation from {businessName} to use {app.displayName}. To gain access, create a password.</AuthDescription><Password showWellDone={this.showWellDone} /></AuthSurface>;
    }
}

class Password extends Component {
    static contextType = SetupPasswordContainerContext;

    state = {
        password: "",
        confirmPassword: "",
        inputErrors: [],
        errorMessage: "",
        loading: false
    };

    submitSetupPassword = (e) => {
        const { password, confirmPassword } = this.state;

        e.preventDefault();
        let errorArray = [];

        this.setState({
            inputErrors: [],
            errorMessage: ""
        });

        if (password.trim() === "") {
            errorArray.push(SetupPasswordError.EMPTY_PASSWORD);
        } else if (password.length < 8) {
            errorArray.push(SetupPasswordError.MIN_LENGTH);
        }
        else if (confirmPassword.trim() === "") {
            errorArray.push(SetupPasswordError.EMPTY_CONFIRM_PASSWORD);
        } else if (password !== confirmPassword) {
            errorArray.push(SetupPasswordError.DIFF_PASS);
        }

        if (errorArray.length !== 0) {   
            this.setState({
                inputErrors: errorArray,
                errorMessage: ""
            });
        } else {
            this.requestSubmitPassword();
        }
    };

    requestSubmitPassword = () => {
        const { password } = this.state;
        const { shortTermToken } = this.context;
        const { showWellDone } = this.props;

        this.setState({
            loading: true
        });

        axios.put(`${API_URL}/setupPassword/${shortTermToken}`, {
            password: password,
        })
            .then(response => {
                this.setState({ loading: false });
                showWellDone(true);
            })
            .catch(error => {
                this.setState({
                    errorMessage: error.getApiErrorDetails().message,
                    loading: false
                });
            });
    };

    render() {
        const { inputErrors, errorMessage, loading } = this.state;
        
        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);

        const passwordErrors = getErrorStrings(SetupPasswordError.EMPTY_PASSWORD, SetupPasswordError.MIN_LENGTH);
        const confirmErrors = getErrorStrings(SetupPasswordError.EMPTY_CONFIRM_PASSWORD, SetupPasswordError.DIFF_PASS);
        
        return <AuthForm onSubmit={this.submitSetupPassword}>{errorMessage.length > 0 && <ErrorLabel align="center">{errorMessage}</ErrorLabel>}<AuthInput placeholder="Enter password" type="password" onChange={event => this.setState({ password: event.target.value })} />{passwordErrors.map(error => <ErrorLabel align="center" key={error}>{error}</ErrorLabel>)}<AuthInput placeholder="Re-enter password" type="password" onChange={event => this.setState({ confirmPassword: event.target.value })} />{confirmErrors.map(error => <ErrorLabel align="center" key={error}>{error}</ErrorLabel>)}{loading ? <LottieLoadingIndicator height="3rem" width="3rem" /> : <AuthPrimaryButton type="submit">Done</AuthPrimaryButton>}</AuthForm>;
    }
}

export default SetupPassword;
